import React, { useContext, useEffect, useState } from 'react';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

function PreloadWorkerComponent() {
	const [bundles, setBundles] = useState([]);
	const [loading, setLoading] = useState(true);
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const baseUrl = 'https://' + onelpsParams.preload.gameCdnPrefix +  onelpsParams.marketId + '.' + onelpsParams.preload.gameCdnDomain + '/';
	const jsonToFetch = baseUrl + onelpsParams.preload.filename;

	useEffect(() => {
		const workerCode = `
			self.addEventListener('message', function(event) {
				const urls = event.data;
				const fetchPromises = urls.map(url =>
					fetch(url)
						.then(response => response.blob())
						.then(blob => ({ status: 'success', url, blob }))
						.catch(error => ({ status: 'error', url, error }))
				);

				Promise.all(fetchPromises).then(results => {
					self.postMessage(results);
				});
			});
		`;

		const blob = new Blob([workerCode], { type: 'application/javascript' });
		const workerUrl = URL.createObjectURL(blob);

		fetch(jsonToFetch)
			.then(response => response.json())
			.then(data => {
				if (window.Worker) {
					const worker = new Worker(workerUrl);
					worker.postMessage(data.assets);

					worker.addEventListener('message', function(event) {
						setBundles(event.data);
						setLoading(false);
					});

					worker.addEventListener('error', function(error) {
						console.error('Worker error:', error);
						setLoading(false);
					});
				} else {
					console.error('Web Workers are not supported in this browser.');
					setLoading(false);
				}
			})
			.catch(error => {
				console.error('Failed:', error);
				setLoading(false);
			});
	}, []);

	return (
		<>
			{ loading ? (
				<div>Loading assets...</div>
			) : (
				<>
					{bundles.map((result, index) => (
						<link
							key={ index }
							rel='preload'
							as='fetch'
							href={ baseUrl + result.url }
							crossOrigin='true'
						/>
					))}
				</>
			)}
		</>
	);
}

export default PreloadWorkerComponent;
